import { Component, Input } from '@angular/core';
import { CONTRIBUTION_TYPE } from '../../../_core/constants/Contribute';
import { Configuration } from '../../../app.constants';
import { EnvironmentNames } from './../../../_core/constants/environments';

@Component({
  selector: 'app-footer-section',
  templateUrl: './footer-section.component.html',
  styleUrls: ['./footer-section.component.scss'],
  standalone: false,
})
export class FooterSectionComponent {
  @Input() fundName;
  @Input() display;
  @Input() validFundName;
  @Input() customLink;
  @Input() contributionType;
  @Input() isPublic;
  @Input() portalLoginLink;
  @Input() homepageLink;

  environments = EnvironmentNames;
  contributionOther = CONTRIBUTION_TYPE.OTHER_ASSETS;
  environmentName: string;

  constructor(config: Configuration) {
    this.environmentName = config.environmentName;
  }
}
